// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__+jZHY","card":"Card_card__-SwHU","banner":"Card_banner__1Y9cv","pill":"Card_pill__oGeUL","titleWrapper":"Card_titleWrapper__GdvUU","chip":"Card_chip__agKFm"};